import React from 'react';
import { Route } from 'react-router-dom';
import { AuthContext } from '@shared/contexts';
import { getRCRedirectUri } from '@utils';

/**
 * Route component that ensures authorization for protected routes.
 */
export default ({ component: Component, currentUser, ...rest }) => {
  const { isAuthenticated } = React.useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthenticated) {
          return <Component {...props} />;
        } else {
          window.location.replace(getRCRedirectUri());
        }
      }}
    />
  );
};
